import { Component, type ReactNode, type ErrorInfo } from "react"

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: "sans-serif", color: "#fff", background: "#1a1a1a", minHeight: "100vh" }}>
          <h1 style={{ color: "#ef4444", marginBottom: 16 }}>Something went wrong</h1>
          <pre style={{ background: "#2a2a2a", padding: 16, borderRadius: 8, overflow: "auto", fontSize: 14 }}>
            {this.state.error?.message}
            {"\n\n"}
            {this.state.error?.stack}
          </pre>
          <button
            onClick={() => {
              localStorage.clear()
              window.location.href = "/login"
            }}
            style={{ marginTop: 16, padding: "8px 16px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" }}
          >
            Clear session & go to login
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
